import { render, staticRenderFns } from "./form-memo-edit.vue?vue&type=template&id=3f9287e1"
import script from "./form-memo-edit.vue?vue&type=script&lang=js"
export * from "./form-memo-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports